import { styled } from '@mui/material';

import { ArrowDropDown } from '../../icons';
import { Theme } from '../../theme';
import { Button } from '../Button';
import { Typography } from '../Typography';

import { SelectGhostButtonSize } from './types';

const getBackground = (theme: Theme, isActive: boolean) => {
  if (isActive) {
    return theme.palette.surface3;
  }

  return 'transparent';
};

const getBorderColor = (theme: Theme, isActive: boolean) => {
  if (isActive) {
    return 'transparent';
  }

  return theme.palette.stateHover;
};

export const SelectGhostButtonStyled = styled(Button, {
  shouldForwardProp: (propName) =>
    propName !== '$isActive' && propName !== '$size',
})<{
  $isActive: boolean;
  $size: SelectGhostButtonSize;
}>(({ theme, $isActive, $size }) => ({
  maxWidth: 260,
  maxHeight: $size === 'small' ? 32 : 28,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  margin: 0,
  gap: 0,
  padding: theme.spacing(1, 2, 1, 3),
  textOverflow: 'ellipsis',
  borderRadius: theme.spacing(4),
  border: '1px solid transparent',
  backgroundColor: getBackground(theme, $isActive),
  textTransform: 'none',

  '& .MuiTypography-button1': {
    width: '100%',
    justifyContent: 'flex-start',
    gap: 0,
    textTransform: 'none',
    padding: 0,
    overflowY: 'hidden',
  },

  '&:hover': {
    border: `1px solid ${getBorderColor(theme, $isActive)}`,
    backgroundColor: getBackground(theme, $isActive),
    transition: 'all 0.3s',

    svg: {
      color: theme.palette.stateHover,
    },
  },
}));

export const SelectGhostButtonValue = styled(Typography)(({ theme }) => ({
  minWidth: 0,
  marginLeft: theme.spacing(1),
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const SelectGhostButtonIcon = styled(ArrowDropDown, {
  shouldForwardProp: (propName) => propName !== '$isActive',
})<{ $isActive: boolean }>(({ theme, $isActive }) => ({
  width: 20,
  height: 20,
  color: $isActive ? theme.palette.stateHover : theme.palette.text2,
  transform: $isActive ? 'rotate(180deg)' : 'rotate(0deg)',
}));
